import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M14.5 16.25H16.5C18.0188 16.25 19.25 15.0188 19.25 13.5C19.25 11.9812 18.0188 10.75 16.5 10.75C16.4897 10.75 16.4793 10.7501 16.469 10.7502C16.4895 10.5863 16.5 10.4194 16.5 10.25C16.5 8.04086 14.7091 6.25 12.5 6.25C10.4456 6.25 8.75298 7.79872 8.5259 9.79233C8.35472 9.76448 8.17905 9.75 8 9.75C6.20507 9.75 4.75 11.2051 4.75 13C4.75 14.7949 6.20507 16.25 8 16.25H9.5M12 18L12 11.5M14.5 14L12 11.5L9.5 14" vectorEffect="non-scaling-stroke" />
	</SVG>
);
